import { Outlet, ScrollRestoration } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { SchemaOrg } from '@/components/seo/SchemaOrg';
import { Hreflang } from '@/components/seo/Hreflang';

/**
 * Marketing layout — used by all public-facing pages (home, about, services,
 * why-us, pricing, contact). Auth-gated routes use a different shell later.
 */
export function MarketingLayout() {
  return (
    <div className="min-h-dvh flex flex-col">
      <SchemaOrg />
      <Hreflang />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ScrollRestoration />
    </div>
  );
}
